import React from 'react';
import NewsCard from './NewsCard';
import SubsctibeCard from './SubscribeCard';
import { data } from './mockData';
import './styles.scss';

const NewsCards = () => (
    <div className="news-cards">
        {data.map((item, index) => (
            <React.Fragment key={item.title}>
                <NewsCard data={item} />
                {index === 5 && <SubsctibeCard />}
            </React.Fragment>
        ))}
    </div>
);

export default NewsCards;
